import React, { useMemo } from 'react';
import { Tooltip, TooltipProps } from '@duxton-web/ui';

import { useUserRolesContext } from '@/contexts/UserRolesContext';
import { AccessTargetInput, UserAction } from '@/utils/accessControl';

export type Props = {
  children: (disabled: boolean, tooltipContent: React.ReactNode) => JSX.Element;
  action: UserAction;
  customActionText?: string;
  tooltipProps?: TooltipProps;
  showTooltip?: boolean;
  techFamilies?: string[];
  accessTargets?: AccessTargetInput[];
  resourceState?: string;
};

export const AccessControlWrapper = ({
  children: renderChildren,
  action,
  customActionText,
  showTooltip = true,
  tooltipProps,
  techFamilies,
  accessTargets,
  resourceState,
}: Props) => {
  const { permissionUtils } = useUserRolesContext();

  const [hasAccess, tooltipContent] = useMemo(() => {
    return permissionUtils.generateExplanation({
      action,
      customActionText,
      techFamilies,
      accessTargets,
      resourceState,
    });
  }, [
    action,
    accessTargets,
    customActionText,
    resourceState,
    techFamilies,
    permissionUtils,
  ]);

  const element = renderChildren(hasAccess, tooltipContent);

  if (hasAccess || !showTooltip) {
    return element;
  }

  return (
    <Tooltip
      title={tooltipContent}
      overlayStyle={{
        maxWidth: 300,
      }}
      {...tooltipProps}
    >
      {element}
    </Tooltip>
  );
};
